import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  return <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-43" data-mp="1mbw54wto8qi1">
      <div className="mx-auto max-w-2xl" data-id="element-44" data-mp="1hdbffrc1pp7u">
        <h2 className="text-center font-heading text-[1.15rem] font-extrabold uppercase text-navy sm:text-[1.75rem]" data-id="element-45" data-mp="1hecsu2gjansq">
          Frequently asked questions
        </h2>
        <div className="mt-2 space-y-1.5" data-id="element-46" data-mp="2a2s4qg4dcpzu">
          {faqs.map(faq => <details key={faq.q} className="group rounded-md border border-navy/10 bg-white px-2.5 py-1.5" data-id="element-47" data-mp="2535ri6ojj9r1">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-2 font-body text-[0.76rem] font-bold text-navy sm:text-[0.88rem]" data-id="element-48" data-mp="202rgcfrn7jos">
                {faq.q}
                <ChevronDownIcon className="h-3.5 w-3.5 shrink-0 text-radio transition-transform duration-150 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-49" data-mp="opyrbcq8l9cf" />
              </summary>
              <p className="mt-1 text-[0.76rem] leading-[1.35] text-graphite sm:text-[0.88rem]" data-id="element-50" data-mp="1klnjc7dxecl1">
                {faq.a}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}